import React, { Component } from 'react';
import CustomProduct from './CustomProduct';
import { isMobile } from "react-device-detect";
import { serverResponse } from '../../util/fakeServer';

export default class CustomSlide extends Component {

    render() {

        const containerClass = {
            position: "relative",
            display: "inline-block",
            // width: "100%",
        }

        const imgClass = {
            maxHeight: "calc(100vh - 100px)",
            // minHeight: "500px",
            maxWidth: "100%"
        }

        const imgMobileClass = {
            width: "100%"
        }

        let align_page = "left";
        if (this.props.pageNumber % 2 == 0) {
            align_page = "right";
        }
        if (!serverResponse.leaflet.hasOwnProperty("index")) {
            if (this.props.pageNumber % 2 == 0) {
                align_page = "left";
            }
            else
            {
                align_page = "right";
            }
        }

        if(isMobile){
            align_page = 'center';
        }

        const wrapperClass = {
            width: "100%",
            textAlign: align_page,
        }

        const listProducts = this.props.products.map((element, key) =>
            <CustomProduct key={key} info={element} leafletSwipe={this.props.leafletSwipe} isSwipeDisabed={this.props.isSwipeDisabed} setSwipe={this.props.setSwipe} />
        )

        return (
            <div style={wrapperClass}>
                <div style={containerClass}>
                    <img className="checkMobileClassImg" src={process.env.PUBLIC_URL + this.props.imagePath} style={isMobile ? imgMobileClass : imgClass} alt="" />

                    {listProducts}

                </div>
            </div>
        );
    }
}